import { brandCode, DB_BRAND_CODES } from 'constants/brandCodes';
import serviceTypeCodes from 'constants/serviceTypeCodes';
const BELGIUM_COUNTRY_CODE = 'BEL';
const BRUSSELS_UIC = '8814001';

export const hasSNCBLeg = (journey) => {
  if (!journey || !Array.isArray(journey)) {
    return false;
  }
  return journey.some(({ serviceType }) =>
    serviceType && serviceType !== null && serviceType.brandCode ? serviceType.brandCode === brandCode.SNCB : false
  );
};

export const isDBLeg = ({ serviceType } = {}) => DB_BRAND_CODES.includes(serviceType?.brandCode);

export const hasDBLeg = (journey) => (Array.isArray(journey) ? journey.some(isDBLeg) : false);

export const hasPotentialSNCBStationWithoutSNCF = ({ outbound = [], inbound = [] }) =>
  [...outbound, ...inbound].every(({ serviceType }) => serviceType?.code !== serviceTypeCodes.SNCF) &&
  [...outbound, ...inbound].some(
    ({ origin, destination }) =>
      (origin?.countryCode === BELGIUM_COUNTRY_CODE && origin?.uic !== BRUSSELS_UIC) ||
      (destination?.countryCode === BELGIUM_COUNTRY_CODE && destination?.uic !== BRUSSELS_UIC)
  );
